import { Component, inject } from '@angular/core';
import { SaleOrderParameterService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SaleOrderParameterCreateDto,
  SaleOrderParameterDto,
  SaleOrderParameterExcelDownloadDto,
  SaleOrderParameterUpdateDto,
} from '../proxy/controlling/dtos/sale-order-parameter';
import { SALEORDERPARAMETER_CONFIG, SALEORDERPARAMETER_FIELDS } from './sale-order-parameter.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sale-order-parameter',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SaleOrderParameterService, ConfirmationService],
  templateUrl: './sale-order-parameter.html',
  styleUrl: './sale-order-parameter.scss',
})
export class SaleOrderParameter extends BaseCrudComponent<
  SaleOrderParameterDto,
  SaleOrderParameterCreateDto,
  SaleOrderParameterUpdateDto,
  SaleOrderParameterExcelDownloadDto
> {
  service = inject(SaleOrderParameterService);
  config = SALEORDERPARAMETER_CONFIG;
  fields = SALEORDERPARAMETER_FIELDS;

  protected prepareUpdateDto(data: any, selected: SaleOrderParameterDto): SaleOrderParameterUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SaleOrderParameter';
  }
}
